document.documentElement.classList.remove('no-js');

const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
const live = (message) => { const region = $('[data-live-region]'); if (region) region.textContent = message; };
const rootUrl = document.body.dataset.rootUrl || '/';
const localUrl = (path = '') => rootUrl === '/' || path.startsWith(rootUrl) ? path : `${rootUrl.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`;

const menuButton = $('[data-menu-toggle]');
const mobileMenu = $('[data-mobile-menu]');
const setMenuOpen = (open, returnFocus = false) => {
  if (!menuButton || !mobileMenu) return;
  menuButton.setAttribute('aria-expanded', String(open));
  mobileMenu.hidden = !open;
  if (open) $('a, button, select', mobileMenu)?.focus();
  else if (returnFocus) menuButton.focus();
};
menuButton?.addEventListener('click', () => setMenuOpen(menuButton.getAttribute('aria-expanded') !== 'true'));
mobileMenu?.addEventListener('click', (event) => { if (event.target.closest('a')) setMenuOpen(false); });
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && menuButton?.getAttribute('aria-expanded') === 'true') setMenuOpen(false, true);
});

const searchDialog = $('[data-search-dialog]');
$('[data-search-open]')?.addEventListener('click', () => { searchDialog?.showModal(); $('[data-predictive-input]')?.focus(); });
$('[data-search-close]')?.addEventListener('click', () => searchDialog?.close());
searchDialog?.addEventListener('click', (event) => { if (event.target === searchDialog) searchDialog.close(); });

$$('[data-language-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

let searchTimer;
$('[data-predictive-input]')?.addEventListener('input', (event) => {
  clearTimeout(searchTimer);
  const query = event.target.value.trim();
  const results = $('[data-predictive-results]');
  if (!results || query.length < 2) { if (results) results.innerHTML = ''; return; }
  searchTimer = setTimeout(async () => {
    try {
      const response = await fetch(`${localUrl('/search/suggest.json')}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`);
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      results.innerHTML = products.map((product) => `<a href="${localUrl(product.url)}">${product.image ? `<img src="${product.image}" alt="">` : ''}<span><bdi dir="auto">${escapeHtml(product.title)}</bdi></span><strong>${escapeHtml(product.price)}</strong></a>`).join('');
    } catch { results.innerHTML = ''; }
  }, 180);
});

const cartDrawer = $('[data-cart-drawer]');
$('[data-cart-open]')?.addEventListener('click', () => cartDrawer?.showModal());
$$('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));
cartDrawer?.addEventListener('click', (event) => { if (event.target === cartDrawer) cartDrawer.close(); });

async function refreshCart(open = false) {
  const response = await fetch('/cart.js', { cache: 'no-store' });
  const cart = await response.json();
  $$('[data-cart-count]').forEach((node) => node.textContent = cart.item_count);
  const content = $('[data-cart-drawer-content]');
  if (content) {
    if (!cart.item_count) content.innerHTML = `<p>${escapeHtml(cartDrawer?.dataset.emptyText)}</p>`;
    else content.innerHTML = `<ul class="studio-mini-cart" role="list">${cart.items.map((item) => `<li>${item.image ? `<a href="${localUrl(item.url)}" aria-label="${escapeHtml(item.product_title)}"><img width="90" height="90" src="${escapeHtml(recentImageUrl(item.image, 180))}" alt=""></a>` : ''}<div><a href="${localUrl(item.url)}"><bdi dir="auto">${escapeHtml(item.product_title)}</bdi></a><small><bdi dir="ltr">${escapeHtml(item.variant_title || '')}</bdi></small><small>${escapeHtml(cartDrawer?.dataset.quantityText)}: ${item.quantity}</small><span>${formatMoney(item.final_line_price, cart.currency)}</span></div></li>`).join('')}</ul><p class="studio-cart-drawer__subtotal"><span>${escapeHtml(cartDrawer?.dataset.subtotalText)}</span><strong>${formatMoney(cart.total_price, cart.currency)}</strong></p><a class="button button--primary button--full" href="${localUrl('/cart')}">${escapeHtml(cartDrawer?.dataset.cartText)}</a>`;
  }
  if (open && cartDrawer) setTimeout(() => $('[data-cart-open]')?.click(), 0);
  return cart;
}

$$('form[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const submit = $('button[type=submit]', form);
  submit?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart error');
    await new Promise((resolve) => setTimeout(resolve, 180));
    await refreshCart(true);
    live(form.dataset.addedMessage || 'Added to cart');
  } catch { live(cartDrawer?.dataset.errorText || 'Unable to add this item. Please try again.'); }
  finally { submit?.removeAttribute('aria-busy'); }
}));

$$('[data-product-root]').forEach((root) => {
  const variants = JSON.parse($('[data-product-variants]', root)?.textContent || '[]');
  const idInput = $('input[name=id]', root);
  const price = $('[data-product-price]', root);
  const comparePrice = $('[data-product-compare-price]', root);
  const stickyPrice = $('[data-sticky-price]', root);
  const stickySize = $('[data-sticky-size]', root);
  const submit = $('[data-product-submit]', root);
  const sizeReference = $('[data-size-reference]', root);
  const sizeReferenceImage = $('[data-size-reference-image]', root);
  const sizeReferenceLabel = $('[data-size-reference-copy]', root);
  $$('[data-variant-radio]', root).forEach((radio) => radio.addEventListener('change', () => {
    const variant = variants.find((entry) => String(entry.id) === radio.value);
    if (!variant) return;
    idInput.value = variant.id;
    price.textContent = formatMoney(variant.price, root.dataset.currency);
    if (comparePrice) {
      const hasComparePrice = Number(variant.compare_at_price) > Number(variant.price);
      comparePrice.hidden = !hasComparePrice;
      comparePrice.textContent = hasComparePrice ? formatMoney(variant.compare_at_price, root.dataset.currency) : '';
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, root.dataset.currency);
    if (stickySize) stickySize.textContent = variant.public_title || variant.title;
    if (radio.dataset.sizeVisual && sizeReferenceImage) {
      sizeReferenceImage.srcset = radio.dataset.sizeSrcset || '';
      sizeReferenceImage.src = radio.dataset.sizeVisual;
      sizeReferenceImage.alt = radio.dataset.sizeVisualAlt || '';
      sizeReferenceImage.hidden = false;
      if (sizeReference) sizeReference.hidden = false;
    }
    if (sizeReferenceLabel && radio.dataset.sizeReferenceLabel) sizeReferenceLabel.textContent = radio.dataset.sizeReferenceLabel;
    submit.disabled = !variant.available;
    const variantUrl = new URL(location.href); variantUrl.searchParams.set('variant', variant.id); variantUrl.searchParams.set('preview_theme_id', document.body.dataset.previewThemeId); history.replaceState({}, '', variantUrl);
  }));
  const mainSubmit = $('[data-product-submit]', root);
  const sticky = $('[data-sticky-cart]', root);
  if (mainSubmit && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(mainSubmit);
  }
  $('[data-sticky-submit]', root)?.addEventListener('click', () => $('form[data-product-form]', root)?.requestSubmit());
});

$$('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
  const gallery = button.closest('[data-product-gallery]');
  const slide = $(`#${CSS.escape(button.dataset.target)}`, gallery);
  slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  $$('[data-gallery-thumb]', gallery).forEach((item) => item.setAttribute('aria-current', String(item === button)));
}));

$$('[data-product-handle]').forEach((section) => {
  const current = section.dataset.productHandle;
  let stored = [];
  try {
    const recent = JSON.parse(localStorage.getItem('easyart-redesign-recent') || '[]');
    stored = Array.isArray(recent) ? recent.filter(handle => typeof handle === 'string' && handle !== current) : [];
    localStorage.setItem('easyart-redesign-recent', JSON.stringify([current, ...stored].slice(0, 6)));
  } catch {}
  const target = $('[data-recent-grid]');
  if (!target || !stored.length) return;
  Promise.all(stored.slice(0, 4).map((handle) => fetch(`${rootUrl}products/${handle}.js`).then((r) => r.ok ? r.json() : null))).then((products) => {
    target.innerHTML = products.filter(Boolean).map((product) => `<article class="studio-product-card"><a class="studio-product-card__media" href="${localUrl(product.url)}"><img loading="lazy" width="600" height="600" src="${escapeHtml(recentImageUrl(product.featured_image))}" alt="${escapeHtml(product.title)}"></a><div class="studio-product-card__body"><a class="studio-product-card__title" href="${localUrl(product.url)}"><bdi dir="auto">${escapeHtml(product.title)}</bdi></a><p class="studio-product-card__price">${formatMoney(product.price, section.dataset.currency)}</p></div></article>`).join('');
    target.closest('[data-recent-section]')?.removeAttribute('hidden');
  }).catch(() => {});
});

function formatMoney(cents, currency = 'AED') { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100); }
function escapeHtml(value = '') { const div = document.createElement('div'); div.textContent = value; return div.innerHTML; }

const previewId = new URL(location.href).searchParams.get('preview_theme_id') || document.body.dataset.previewThemeId;
function keepPreview(root = document) {
  const linkSelector = previewId ? 'a[href]' : 'a.studio-language-link[href]';
  const links = [...root.querySelectorAll(linkSelector)];
  if (root.matches?.(linkSelector)) links.unshift(root);
  links.forEach(a => {
    const url = new URL(a.href, location.origin);
    if (url.origin !== location.origin || !/^https?:/.test(url.protocol)) return;
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    if (a.classList.contains('studio-language-link')) { const here = new URL(location.href); for (const [key,value] of here.searchParams) url.searchParams.set(key,value); url.hash=here.hash; }
    if (a.href !== url.href) a.href = url.href;
  });
  if (previewId) root.querySelectorAll('form[method="get"]').forEach(form => { if (!form.querySelector('[name="preview_theme_id"]')) {const input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';input.value=previewId;form.append(input);} });
}
keepPreview();
if (previewId) new MutationObserver(records => {for (const r of records) for (const n of r.addedNodes) if (n.nodeType===1) keepPreview(n);}).observe(document.body,{childList:true,subtree:true});
document.addEventListener('click', event => {
  const languageLink = event.target.closest?.('a.studio-language-link[href]');
  if (languageLink) keepPreview(languageLink);
});
document.querySelectorAll('[data-ea-catalog]').forEach(root => {
 const grid=root.querySelector('[data-ea-grid]'); if(!grid)return;
 const cards=[...grid.children]; const buttons=[...root.querySelectorAll('[data-ea-filter]')];
 function filter() {const key=location.hash.slice(1)||'all';const active=buttons.some(b=>b.dataset.eaFilter===key)?key:'all';let n=0;cards.forEach(c=>{const hidden=active!=='all'&&c.dataset.eaCategory!==active;if(c.hidden!==hidden)c.hidden=hidden;if(!hidden)n++;});buttons.forEach(b=>{const pressed=String(b.dataset.eaFilter===active);if(b.getAttribute('aria-pressed')!==pressed)b.setAttribute('aria-pressed',pressed);}); const count=root.querySelector('[data-ea-result-count]');if(count&&count.textContent!==String(n))count.textContent=n;}
 buttons.forEach(b=>b.addEventListener('click',()=>{history.replaceState({},'',location.pathname+location.search+'#'+b.dataset.eaFilter);filter();}));
 window.addEventListener('hashchange',filter);filter();
 root.querySelector('[data-ea-sort]')?.addEventListener('change',e=>{const sorted=[...cards];if(e.target.value==='low')sorted.sort((a,b)=>Number(a.dataset.eaPrice)-Number(b.dataset.eaPrice));if(e.target.value==='high')sorted.sort((a,b)=>Number(b.dataset.eaPrice)-Number(a.dataset.eaPrice));if(e.target.value==='name')sorted.sort((a,b)=>a.dataset.eaTitle.localeCompare(b.dataset.eaTitle));sorted.forEach(c=>grid.append(c));});
});

(() => {
 const legacy = location.hash.slice(1);
 if (!legacy || !location.pathname.endsWith('/collections/all')) return;
 const link = [...document.querySelectorAll('[data-legacy-subject]')].find(el => el.dataset.legacySubject === legacy);
 if (!link || legacy === 'all') return;
 const next = new URL(link.href, location.origin);
 const preview = new URLSearchParams(location.search).get('preview_theme_id');
 if (preview) next.searchParams.set('preview_theme_id', preview);
 location.replace(next.toString());
})();

function recentImageUrl(source, width = 600) { if (!source) return ""; const url = new URL(source, location.origin); url.searchParams.set("width", String(width)); return url.toString(); }
